import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const PRICES_TABS = [
  'product',
  'options',
  'variants',
  'slots',
  'dynamic_discounts',
  'discounts_bysold',
  'price_groups',
  'memberships',
] as const;

export type PricesTabs = (typeof PRICES_TABS)[number];

export const PricesPath: MainPath = '/prices/:id?/:section?';

export const PricesRoute: MainNavRoute = {
  path: '/prices',
  label: 'routes.prices',
  icon: 'money',
  type: 1,
  hidden: true,
  // kb: 'https://doc.clickup.com/20614177/p/h/kn311-23801/127b2e39cbbd79a',
  permissions: [PERMISSIONS.PRODUCTS__LIST],
  children: [
    {
      path: ':id',
      disowned: true,
      permissions: [PERMISSIONS.PRODUCTS__DETAILS],
      children: makeChildren<PricesTabs>({
        product: { path: 'product' },
        options: { path: 'options' },
        variants: { path: 'variants' },
        slots: { path: 'slots' },
        dynamic_discounts: { path: 'dynamic_discounts' },
        discounts_bysold: { path: 'discounts_bysold' },
        price_groups: { path: 'price_groups' },
        memberships: { path: 'memberships' },
      }),
    },
  ],
};
